import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Row, Col } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faEdit, faExclamation, faHome, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Form, Input, Modal, Button as AntButton, Table, Space, Tag, Upload, Select, Empty, Tooltip } from 'antd';
import { InboxOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { createListItems, createPayFeature, createPos, updateListItems } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
// import { featureAlert, featureResponse, features, homePage, homeRefresh } from '../../../states/home';
import { dummyRequest, getHtml } from '../../../services/utilities';
import GramCard from './GramCard';
import GramListCard from './GramListCard';
import { featureAlert, featureResponse, posRefresh, posPage } from '../../../states/wayaPos';
import { Editor } from 'react-draft-wysiwyg';
// import MediaCard from './MediaCard';

const WayaPos = () => {
  // const data = useRecoilValueLoadable(features)
  const data = useRecoilValue(posPage)
  const [viewModal, setViewModal] = useState(false)
  const [viewModal2, setViewModal2] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState({})
  const [file, setFile] = useState("")
  const [showAlert, setShowAlert] = useRecoilState(featureAlert);
  const [response, setResponse] = useRecoilState(featureResponse)
  const [uploadImage, setUploadImage] = useState(false)
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const [desc, setDesc] = useState(false)
  const [ben, setBen] = useState(false)
  const setRefresh = useSetRecoilState(posRefresh)
  const [form] = Form.useForm()
  const { Option } = Select;
  const { confirm } = Modal;
  const posCall = data?.data && data?.data
  const { pos, section2, section3, section4, section5, others } = posCall ? posCall : []
  console.log(posCall)

  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    // fd.append('linkUrl', val.link_url)
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    fd.append('position', val.position)
    fd.append('google_url', val.google_url)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('parent_id', val.parent_id)
    fd.append('type', val.type)
    fd.append('file', file);
    const res = await createPos(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
  const onFinish2 = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('type', val.type)
    fd.append('sub_title', val.sub_title)
    fd.append('file', file);
    const res = await createListItems(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal2(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };

  const onFinishUpdate = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('sub_title', val.sub_title)
    fd.append('file', file);
    try {
      const res = await updateListItems({ data: fd, id:val.id })
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setEditModal(false)
        setFile()
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
        setFile()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
    setFile()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const onChange = (v) => {
    // if (v === "section2") { 
    //   setDesc(false)
    //   setUploadImage(false)
    // } else { 
    //   setDesc(true)
    //   setUploadImage(true)
    // }
    if (v === "section4" || v === "section2") { 
      setDesc(false)
      setUploadImage(false)
    } else { 
      setDesc(true)
      setUploadImage(true)
    }
    // if (v === "section3") { 
    //   setDesc(false)
    // } else { 
    //   setDesc(true)
    // }
    if (v === "mainSection") { 
      setBen(true)
    } else { 
      setBen(false)
    }
  }
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Home" />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya POS</Breadcrumb.Item>
            <Breadcrumb.Item active>Waya-POS</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Waya-POS Page</h4>
        </div>
        <div className="table-settings mb-4">
          <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
            Create New Feature <FontAwesomeIcon icon={faHome} className="d-none d-sm-inline ms-1" />
          </Button>
        </div>
      </div>
      <h4>Waya-POS Home</h4>
      {pos && pos && 
      pos.length === 0 ? <Empty />:
      pos && pos.map(dat =>
        <GramCard key={dat.id} featureImg={true} img={dat.image_url} description={dat.description} title={dat.title} 
          type="POS" id={dat.id} link={true} status={dat.status} url="/admin/home_page/hero" name='Home Feature'
          google_url={dat.google_url} app_url={dat.app_url} get_start_url={dat.get_start_url} position={dat.position}
        />
      )}
      
      <Row>
        <h4>Waya-POS Section 2</h4>
        {section2 && section2 &&  
        section2.length === 0 ? <Empty />:
        section2 && section2.map(ex =>
        <Col xs={12} xl={3} md={6} lg={4} key={ex.id}>
          <GramCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="section2" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
         </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-POS Section 3</h4>
        {section3 && section3 && 
        section3.length === 0 ? <Empty />:
        section3 && section3.map(ex =>
          // <Col xs={12} xl={4} lg={4} key={ex.id}>
          <GramListCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="POS" id={ex.id} status={ex.status} link_url={ex.link_url} name='Benefit' 
            desc={true} ben={false} uploadImage={false} listItem={ex.posItem} featureImg={true}
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
          // </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-POS Section 4</h4>
        {section4 && section4 && 
        section4.length === 0 ? <Empty />:
        section4 && section4.map(ex =>
          <GramListCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="SEC" id={ex.id} status={ex.status} link_url={ex.link_url} name='Sales Point' 
            desc={true} ben={false} uploadImage={false} listItem={ex.posItem} featureImg={true}
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
        )}
      </Row>
      {/* <Row>
        <h4>Waya-POS Section 4</h4>
        {section4 && section4 &&  
        section4.length === 0 ? <Empty />:
        section4 && section4.map(ex =>
        <Col xs={12} xl={3} md={6} lg={3} key={ex.id}>
          <GramCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="product" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
          />
         </Col>
        )}
      </Row> */}
      <Row>
        <h4>Waya-POS Section 5</h4>
        {section5 && section5 &&  
        section5.length === 0 ? <Empty />:
        section5 && section5.map(ex =>
        <Col key={ex.id}>
          <GramCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="POS" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
         </Col>
        )}
      </Row>
      <Row>
        <h4>Waya-POS Others</h4>
        {others && others &&  
        others.length === 0 ? <Empty />:
        others && others.map(ex =>
        <Col key={ex.id}>
          <GramCard key={ex.id} img={ex.image_url} description={ex.description} title={ex.title} 
            type="POS" id={ex.id} status={ex.status} link_url={ex.link_url} name='Product & Services'
            google_url={ex.google_url} app_url={ex.app_url} get_start_url={ex.get_start_url} position={ex.position}
          />
         </Col>
        )}
      </Row>


      {/*create feature start */}
      <Modal
        title="Create New Feature"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={onChange}>
              <Option key='1' value="mainSection">Waya-POS Home</Option>
              <Option key='2' value="section2">Waya-POS Section 2</Option>
              <Option key='3' value="section3">Waya-POS Section 3</Option>
              <Option key='4' value="section4">Waya-POS Section 4</Option>
              <Option key='5' value="section5">Waya-POS Section 5</Option>
              <Option key='6' value="others">Waya-POS Others</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          {/* {desc && uploadImage && */}
            <Form.Item label="Description" name="description">
              {/* <Input.TextArea /> */}
              <Editor
                editorState={editorDesc}
                editorClassName="px-3 border border-gray-1"
                editorStyle={{
                  height: 100,
                  overflow: 'auto',
                }}
                onEditorStateChange={onEditorStateChanges}
              />
            </Form.Item>
            <Form.Item label="Position" name="position">
              <Input type='number' />
            </Form.Item>
          {/* } */}
          {/* {ben &&
            <Form.Item label="Button URL 1" name="link_url">
              <Input />
            </Form.Item>
          }           */}          
          <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
            <Form.Item label="App Store Link" name="app_url">
              <Input />
            </Form.Item>
            <Form.Item label="Get Started Link" name="get_start_url">
              <Input />
            </Form.Item>
          {/* {desc && uploadImage && */}
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          {/* } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

    {/*create Product start */}
      <Modal
        title="Create New Product Feature"
        centered
        visible={viewModal2}
        footer={null}
        onCancel={() => setViewModal2(false)}
      >
        <Form form={form} onFinish={onFinish2} layout="vertical">
          <Form.Item label="Type" hidden initialValue='product' name="type" rules={[{ required: true }]}>
            <Input hidden />
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Desc Title" name="sub_title">
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

      {/* update feature start */}
      <Modal
        title="Update Feature"
        centered
        visible={editModal}
        footer={null}
        onCancel={() => setEditModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical" initialValues={{ title: value.title, description: value.description, id: value.id, image_url: value.image_url, sub_title: value.sub_title }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Desc Title" name="sub_title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            <Input.TextArea />
          </Form.Item>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* update feature end */}
    </div>
  )
}

export default WayaPos